import React, { cloneElement } from "react";
import type { FieldProps } from "@rjsf/utils";
import { spacing } from "../../../../../../../../stitches.config";
import { BuilderFieldWrapper } from "../__styles__/FieldPreviews";

type BaseFieldPreviewProps = FieldProps & {
  children: React.JSX.Element;
};

export function BaseFieldPreview({ children }: BaseFieldPreviewProps) {
  return (
    <BuilderFieldWrapper>
      <div style={{ marginBottom: spacing.xs.toString() }}>
        {cloneElement(children, { isSubmissionBuilder: true })}
      </div>
    </BuilderFieldWrapper>
  );
}
